export const comics = [
  {
    id: "solo-leveling",
    title: "我独自升级",
    titleEn: "Solo Leveling",
    author: "Chugong",
    artist: "Jang Sung-rak",
    category: "热血",
    tags: ["战斗", "奇幻", "升级", "系统"],
    rating: 4.9,
    views: "1280万",
    chapters: 201,
    status: "已完结",
    updateDate: "2025-12-01",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20male%20protagonist%20with%20dark%20purple%20aura%2C%20shadow%20warriors%20emerging%20from%20behind%2C%20clean%20minimalist%20background%20with%20subtle%20gradient%2C%20anime%20art%20style%2C%20dramatic%20lighting%2C%20professional%20illustration%2C%20high%20contrast%2C%20modern%20digital%20art%20with%20smooth%20rendering&width=600&height=800&seq=solo-leveling-cover&orientation=portrait",
    description: "十年前，神秘的地下城开始出现在世界各地，觉醒者们获得了超自然能力。成秦宇，被称为人类最弱兵器的E级猎人，在一次双重地下城事件中经历了生死考验，意外获得了升级系统的能力。从此，他开始了一段从最弱到最强的逆袭之路。",
    featured: true,
    hot: true,
  },
  {
    id: "true-beauty",
    title: "女神降临",
    titleEn: "True Beauty",
    author: "Yaongyi",
    artist: "Yaongyi",
    category: "恋爱",
    tags: ["校园", "化妆", "爱情", "成长"],
    rating: 4.7,
    views: "960万",
    chapters: 224,
    status: "已完结",
    updateDate: "2025-11-15",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20beautiful%20young%20woman%20with%20flawless%20makeup%2C%20half%20face%20showing%20natural%20look%20and%20other%20half%20with%20perfect%20makeup%2C%20soft%20pink%20and%20peach%20pastel%20background%2C%20romantic%20anime%20illustration%20style%2C%20gentle%20lighting%2C%20clean%20lines%2C%20elegant%20digital%20art&width=600&height=800&seq=true-beauty-cover&orientation=portrait",
    description: "林周京，一个因外貌被欺负的女孩，通过化妆技巧彻底改变了自己的形象，成为了学校里的女神。但在这美丽的外表下，她始终担心真实的自己被发现。两个截然不同的男孩闯入了她的生活，一个知道她的秘密，一个爱上了真实的她。",
    featured: true,
    hot: true,
  },
  {
    id: "tower-of-god",
    title: "神之塔",
    titleEn: "Tower of God",
    author: "SIU",
    artist: "SIU",
    category: "奇幻",
    tags: ["冒险", "战斗", "世界观", "长篇"],
    rating: 4.8,
    views: "1100万",
    chapters: 580,
    status: "连载中",
    updateDate: "2026-07-05",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20boy%20climbing%20a%20massive%20glowing%20tower%2C%20magical%20creatures%20and%20warriors%20surrounding%2C%20dark%20blue%20cosmic%20background%20with%20stars%2C%20epic%20fantasy%20illustration%2C%20dramatic%20scale%2C%20intricate%20details%2C%20professional%20digital%20art&width=600&height=800&seq=tower-of-god-cover&orientation=portrait",
    description: "二十四夜，一个生活在塔外的少年，为了追随唯一的朋友蕾哈尔，决定进入神秘的神之塔。在这座塔中，每一层都是一个不同的世界，存在着各种危险的测试和强大的对手。他的冒险从此开始，而塔顶究竟隐藏着什么秘密？",
    featured: true,
    hot: true,
  },
  {
    id: "lookism",
    title: "看脸时代",
    titleEn: "Lookism",
    author: "朴泰俊",
    artist: "朴泰俊",
    category: "剧情",
    tags: ["校园", "社会", "动作", "成长"],
    rating: 4.6,
    views: "890万",
    chapters: 470,
    status: "连载中",
    updateDate: "2026-07-06",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20one%20person%20split%20into%20two%20bodies%20showing%20contrast%20between%20overweight%20and%20handsome%20young%20man%2C%20school%20setting%20in%20background%2C%20dramatic%20dual%20portrait%20composition%2C%20clean%20minimalist%20style%2C%20urban%20Korean%20aesthetic%2C%20professional%20illustration&width=600&height=800&seq=lookism-cover&orientation=portrait",
    description: "朴亨硕，一个因为肥胖外貌而遭受校园霸凌的男生，某天醒来发现自己拥有了另一个完美的身体。从此他过上了白天是帅气美男、晚上是原来自己的双重生活。通过两个身体，他逐渐看清了这个看脸世界的真相。",
    featured: false,
    hot: true,
  },
  {
    id: "business-proposal",
    title: "社内相亲",
    titleEn: "A Business Proposal",
    author: "Haehwa",
    artist: "NARAK",
    category: "恋爱",
    tags: ["职场", "喜剧", "爱情", "契约"],
    rating: 4.5,
    views: "720万",
    chapters: 124,
    status: "已完结",
    updateDate: "2025-10-20",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20young%20couple%20in%20formal%20office%20attire%2C%20romantic%20tension%20between%20CEO%20and%20employee%2C%20soft%20warm%20lighting%2C%20modern%20office%20background%20with%20cityscape%20view%2C%20romantic%20comedy%20illustration%2C%20clean%20lines%2C%20professional%20digital%20art&width=600&height=800&seq=business-proposal-cover&orientation=portrait",
    description: "申夏莉，一个普通的食品研究员，替闺蜜去相亲却意外发现相亲对象竟是自己的公司CEO姜泰武。为了不被发现真实身份，她展开了一场啼笑皆非的双面人生。",
    featured: false,
    hot: false,
  },
  {
    id: "god-of-highschool",
    title: "高校之神",
    titleEn: "The God of High School",
    author: "朴永济",
    artist: "朴永济",
    category: "热血",
    tags: ["格斗", "校园", "超能力", "神话"],
    rating: 4.4,
    views: "650万",
    chapters: 569,
    status: "已完结",
    updateDate: "2025-08-30",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20teenage%20martial%20artist%20in%20dynamic%20fighting%20pose%2C%20energy%20aura%20surrounding%20body%2C%20tournament%20arena%20background%2C%20intense%20action%20scene%2C%20fiery%20orange%20and%20red%20accents%2C%20professional%20digital%20illustration%2C%20smooth%20shading&width=600&height=800&seq=god-of-highschool-cover&orientation=portrait",
    description: "全国高中生格斗大赛即将开始，来自各地的武术高手汇聚一堂。陈毛利，一个热爱跆拳道的少年，受朋友邀请参加比赛，却逐渐发现这场比赛背后隐藏着远超想象的惊天秘密。",
    featured: false,
    hot: false,
  },
  {
    id: "eleceed",
    title: "超能警探",
    titleEn: "Eleceed",
    author: "Son Jeho",
    artist: "ZHENA",
    category: "奇幻",
    tags: ["超能力", "动作", "猫", "幽默"],
    rating: 4.8,
    views: "850万",
    chapters: 320,
    status: "连载中",
    updateDate: "2026-07-04",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20hero%20with%20electric%20powers%20and%20a%20fat%20cat%20companion%2C%20action%20pose%20with%20lightning%20effects%2C%20urban%20city%20background%20at%20night%2C%20dynamic%20composition%2C%20vibrant%20blue%20and%20white%20lightning%2C%20professional%20illustration&width=600&height=800&seq=eleceed-cover&orientation=portrait",
    description: "姜修，一位拥有闪电超能力的少年，在一次意外中救下了一只神秘的猫，却发现这只猫其实是世界顶尖超能力者的化身。从此，他踏上了成为最强超能力者的训练之路。",
    featured: true,
    hot: true,
  },
  {
    id: "sweet-home",
    title: "甜蜜家园",
    titleEn: "Sweet Home",
    author: "金坎比",
    artist: "黄英灿",
    category: "惊悚",
    tags: ["恐怖", "生存", "怪物", "末日"],
    rating: 4.7,
    views: "780万",
    chapters: 140,
    status: "已完结",
    updateDate: "2025-06-15",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dark%20apocalyptic%20scene%20with%20monster%20silhouette%20looming%20over%20apartment%20building%2C%20survivors%20hiding%20in%20shadows%2C%20gritty%20horror%20atmosphere%2C%20dark%20muted%20colors%20with%20red%20accents%2C%20suspenseful%20composition%2C%20professional%20dark%20digital%20art&width=600&height=800&seq=sweet-home-cover&orientation=portrait",
    description: "车贤秀，一个因校园暴力和家庭变故而绝望的少年，搬进了一栋老旧公寓准备结束生命。然而末日降临，人类开始变异成怪物，他必须在这个封闭的空间中为生存而战。",
    featured: false,
    hot: false,
  },
  {
    id: "noblesse",
    title: "大贵族",
    titleEn: "Noblesse",
    author: "Son Jeho",
    artist: "李光洙",
    category: "奇幻",
    tags: ["吸血鬼", "校园", "战斗", "贵族"],
    rating: 4.6,
    views: "920万",
    chapters: 544,
    status: "已完结",
    updateDate: "2025-04-10",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20vampire%20noble%20in%20black%20suit%20with%20crimson%20eyes%2C%20gothic%20castle%20background%20with%20moonlight%2C%20aristocratic%20aura%2C%20dark%20and%20refined%20color%20palette%2C%20professional%20illustration%20with%20sharp%20lines%2C%20mysterious%20atmosphere&width=600&height=800&seq=noblesse-cover&orientation=portrait",
    description: "莱杰罗，大贵族中的贵族，沉睡了820年后在现代韩国醒来。他进入一所高中，试图平静地生活，但来自过去和现在的威胁不断涌现。他必须保护身边的人，同时揭开自己沉睡的真相。",
    featured: false,
    hot: false,
  },
  {
    id: "remarried-empress",
    title: "再婚皇后",
    titleEn: "The Remarried Empress",
    author: "Alpha Tart",
    artist: "Sumpul",
    category: "恋爱",
    tags: ["宫斗", "奇幻", "逆袭", "女主"],
    rating: 4.5,
    views: "680万",
    chapters: 168,
    status: "连载中",
    updateDate: "2026-07-01",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20empress%20in%20luxurious%20royal%20gown%20with%20golden%20crown%2C%20palace%20background%20with%20stained%20glass%20windows%2C%20regal%20and%20graceful%20portrait%2C%20soft%20golden%20lighting%2C%20romantic%20fantasy%20illustration%2C%20intricate%20dress%20details&width=600&height=800&seq=remarried-empress-cover&orientation=portrait",
    description: "娜薇，东方帝国的皇后，在得知丈夫要废后另立时，毅然决定离婚并与邻国国王再婚。在那个女性被视为附属品的时代，她用智慧和勇气开创了属于自己的传奇。",
    featured: false,
    hot: false,
  },
  {
    id: "wind-breaker",
    title: "疾风传说",
    titleEn: "Wind Breaker",
    author: "Jo Yongseok",
    artist: "Jo Yongseok",
    category: "热血",
    tags: ["运动", "自行车", "校园", "热血"],
    rating: 4.7,
    views: "550万",
    chapters: 490,
    status: "连载中",
    updateDate: "2026-07-06",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20cyclist%20racing%20on%20mountain%20road%20at%20sunset%2C%20dynamic%20speed%20lines%2C%20wind%20sweeping%20through%20hair%2C%20golden%20hour%20lighting%2C%20sports%20action%20illustration%2C%20professional%20digital%20art%20with%20smooth%20gradients&width=600&height=800&seq=wind-breaker-cover&orientation=portrait",
    description: "赵俊模，一个品学兼优的学生会主席，在一次偶然的机会下接触了自行车运动后，发现了自己内心深处对速度和自由的渴望。他加入了学校的自行车社，开始了一段充满热血和友情的骑行之旅。",
    featured: false,
    hot: false,
  },
  {
    id: "annarasumanara",
    title: "魔幻之音",
    titleEn: "Annarasumanara",
    author: "河一权",
    artist: "河一权",
    category: "剧情",
    tags: ["治愈", "音乐", "成长", "艺术"],
    rating: 4.8,
    views: "420万",
    chapters: 27,
    status: "已完结",
    updateDate: "2025-03-20",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20magician%20performing%20on%20abandoned%20amusement%20park%20stage%2C%20butterflies%20and%20magic%20sparks%20floating%2C%20dreamy%20pastel%20color%20palette%2C%20whimsical%20atmosphere%2C%20artistic%20illustration%20style%2C%20emotional%20and%20touching%20composition&width=600&height=800&seq=annarasumanara-cover&orientation=portrait",
    description: "尹雅伊，一个被现实压得喘不过气的高中生，遇到了住在废弃游乐园里的神秘魔术师李乙。他让她相信，这个世界还有魔法存在。一个关于梦想、自由和成长的感人故事。",
    featured: false,
    hot: false,
  },
];

export const categories = [
  { slug: "all", name: "全部漫画", count: 1280 },
  { slug: "hot-blood", name: "热血", count: 320 },
  { slug: "romance", name: "恋爱", count: 280 },
  { slug: "fantasy", name: "奇幻", count: 250 },
  { slug: "drama", name: "剧情", count: 180 },
  { slug: "thriller", name: "惊悚", count: 95 },
  { slug: "comedy", name: "喜剧", count: 85 },
  { slug: "action", name: "动作", count: 70 },
];

export const reviews = [
  {
    id: 1,
    user: "漫画迷小王",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20male%20character%20portrait%2C%20friendly%20expression%2C%20simple%20clean%20background%2C%20anime%20art%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish",
    rating: 5,
    content: "韩漫屋真的是我用过最舒服的漫画平台！下拉式阅读太方便了，不用一页页翻，而且加载速度很快。漫画种类也很全，几乎我想看的韩漫这里都有。强烈推荐给所有爱看韩国漫画的朋友！",
    date: "2026-07-01",
  },
  {
    id: 2,
    user: "每天必看漫画",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20female%20character%20portrait%2C%20smiling%20warmly%2C%20simple%20clean%20background%2C%20anime%20art%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish",
    rating: 5,
    content: "朋友推荐来的，一开始只是试试看，没想到完全停不下来！界面设计很友好，分类也很清晰，找漫画特别方便。最重要的是更新速度很快，每次新章节出来都能第一时间看到。",
    date: "2026-06-28",
  },
  {
    id: 3,
    user: "资深韩漫读者",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20character%20portrait%20with%20glasses%2C%20intelligent%20expression%2C%20simple%20clean%20background%2C%20anime%20art%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish",
    rating: 5,
    content: "看韩漫五六年了，用过很多平台，韩漫屋是目前体验最好的。下拉式阅读不用频繁翻页，从头看到尾一气呵成。漫画质量也很高，翻译很用心，没有机翻的痕迹。",
    date: "2026-06-25",
  },
  {
    id: 4,
    user: "夜深人静看漫画",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20character%20portrait%20with%20gentle%20smile%2C%20simple%20clean%20background%2C%20anime%20art%20style%2C%20soft%20lighting%2C%20warm%20colors&width=100&height=100&seq=avatar-04&orientation=squarish",
    rating: 4,
    content: "很喜欢韩漫屋的夜间模式，晚上看漫画眼睛不累。漫画库也一直在更新，每周都有新作品上架。希望能增加更多完结漫画，有些喜欢的作品更新太慢了。",
    date: "2026-06-20",
  },
  {
    id: 5,
    user: "漫画收藏家",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20character%20portrait%20with%20cool%20expression%2C%20simple%20clean%20background%2C%20anime%20art%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-05&orientation=squarish",
    rating: 5,
    content: "这个平台的界面设计真心不错，简洁大方，没有乱七八糟的广告。搜索功能也很强大，可以根据分类、作者、标签等多种方式找漫画。已经成为我的主力漫画阅读平台了！",
    date: "2026-06-18",
  },
];

export const faqs = [
  {
    question: "韩漫屋的漫画都是免费的吗？",
    answer: "是的，韩漫屋上的所有漫画都是免费阅读的。我们致力于为广大韩漫爱好者提供优质的免费阅读体验，无需付费即可畅享海量韩国漫画资源。",
  },
  {
    question: "什么是下拉式阅读？",
    answer: "下拉式阅读是一种创新的漫画阅读方式，您只需向下滑动页面即可连续阅读漫画内容，无需像传统翻页方式那样频繁点击翻页。这种阅读方式让漫画阅读体验更加流畅自然，特别适合在手机端阅读长篇漫画。",
  },
  {
    question: "漫画更新频率是怎样的？",
    answer: "我们团队会在第一时间同步最新章节，连载中的漫画通常会在官方更新后的24小时内同步上线。热门漫画的更新速度会更快，确保您不会错过任何精彩内容。",
  },
  {
    question: "如何在韩漫屋上查找特定漫画？",
    answer: "您可以通过首页的搜索栏直接搜索漫画名称，也可以通过分类页面按类型浏览。我们还提供按热度、评分、更新时间等多种排序方式，帮助您快速找到感兴趣的漫画。",
  },
  {
    question: "支持手机端阅读吗？",
    answer: "当然支持！韩漫屋采用响应式设计，完美适配手机、平板和电脑等各种设备。特别是移动端的下拉式阅读体验经过了精心优化，让您随时随地都能享受舒适的漫画阅读。",
  },
  {
    question: "如果发现漫画翻译有问题怎么办？",
    answer: "我们非常重视翻译质量。如果您发现任何翻译问题或错误，可以通过关于我们页面的联系方式向我们反馈。我们会在收到反馈后尽快进行修正，确保为所有读者提供最好的阅读体验。",
  },
];

export const chapters = [
  { number: 201, title: "终章 - 新的开始", date: "2025-12-01", views: "128万" },
  { number: 200, title: "最后的战斗", date: "2025-11-24", views: "156万" },
  { number: 199, title: "觉醒之刻", date: "2025-11-17", views: "142万" },
  { number: 198, title: "王的归来", date: "2025-11-10", views: "138万" },
  { number: 197, title: "影之军团", date: "2025-11-03", views: "165万" },
  { number: 196, title: "最终试炼", date: "2025-10-27", views: "121万" },
  { number: 195, title: "突破极限", date: "2025-10-20", views: "118万" },
  { number: 194, title: "命运之战", date: "2025-10-13", views: "133万" },
  { number: 193, title: "守护之人", date: "2025-10-06", views: "127万" },
  { number: 192, title: "暗影降临", date: "2025-09-29", views: "145万" },
];